"use client";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { keyMetrics as data } from "@/lib/data/partners";

const accents = ["var(--color-amber)", "var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-emerald)", "var(--color-amber)"];

export function KeyMetrics() {
  return (
    <Section id="key-metrics" className="relative">
      <Container>
        <Reveal>
          <div className="text-center max-w-3xl mx-auto mb-10">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {data.metrics.map((m, i) => {
            const c = accents[i % accents.length]!;
            return (
              <Reveal key={m.label} delay={i * 60}>
                <div className="glass rounded-2xl p-5 h-full text-center" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${c} 18%, transparent)` }}>
                  <div className="text-3xl font-bold" style={{ color: c }}>{m.value}</div>
                  <div className="mt-2 text-xs font-semibold uppercase tracking-wider leading-tight" style={{ color: c }}>{m.label}</div>
                  <p className="mt-2 text-[10px] text-[rgb(var(--fg-muted))] leading-relaxed italic">{m.detail}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
